import React from "react";
import { MdCheckCircle, MdError, MdInfo, MdWarning, MdClose } from "react-icons/md";
import { subscribe, dismiss, type Toast } from "../libs/toast";

const ICONS = {
  success: MdCheckCircle,
  error: MdError,
  info: MdInfo,
  warning: MdWarning,
} as const;

type State = { toasts: Toast[] };

export default class ToastViewport extends React.Component<{}, State> {
  state: State = { toasts: [] };
  private _unsub: (() => void) | null = null;

  componentDidMount() {
    this._unsub = subscribe((toasts) => this.setState({ toasts }));
  }

  componentWillUnmount() {
    this._unsub?.();
  }

  render() {
    if (this.state.toasts.length === 0) return null;
    return (
      <div className="vm-toast-viewport" aria-live="polite" aria-atomic="false">
        {this.state.toasts.map((t) => {
          const Icon = ICONS[t.kind];
          return (
            <div key={t.id} className={`vm-toast vm-toast--${t.kind}`} role="status">
              <Icon className="vm-toast__icon" size={20} />
              <span className="vm-toast__text">{t.text}</span>
              <button
                type="button"
                className="vm-toast__close"
                onClick={() => dismiss(t.id)}
                aria-label="Dismiss"
              >
                <MdClose size={16} />
              </button>
            </div>
          );
        })}
      </div>
    );
  }
}
